
import { defineComponent, reactive, ref, computed } from "vue";
import { useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";
import ApiService from "@/core/services/ApiService";
import { COUNTRIES, flagUrl } from "./countries";

export default defineComponent({
  name: "CreateGroup",
  components: { Multiselect },
  setup() {
    const router = useRouter();
    const saving = ref(false);
    const error = ref("");
    const form = reactive({ name: "", tag: "", country: "" });

    const countryOptions = COUNTRIES.map((c) => ({
      value: c.code,
      label: c.name,
      search: `${c.name} ${c.code}`,
      flag: flagUrl(c.code),
    }));

    const valid = computed(
      () => form.name.length >= 3 && form.tag.length >= 2 && form.country !== ""
    );

    const submit = async () => {
      if (!valid.value) return;
      saving.value = true;
      error.value = "";
      try {
        const payload = {
          name: form.name,
          tag: form.tag.toUpperCase(),
          country: form.country,
        };
        await ApiService.post("groups", payload as any);
        router.push("/groups/me");
      } catch (e: any) {
        error.value =
          e?.response?.data?.message ?? "Não foi possível criar o time.";
      } finally {
        saving.value = false;
      }
    };

    return { form, saving, error, valid, submit, countryOptions, maxMembers: 10 };
  },
});
